import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { updateInvitations } from "../../../data/store/overviewSlice"
import { Input, Select, Checkbox, Typography, Button, Space, notification } from 'antd';
import Notify, { notify } from "../Notify";


const { Option } = Select;

const EditMemberInvite = ({ defaultData = {}, onComplete = () => { } }) => {
  const dispatch = useDispatch()
  const { tenantId } = useParams()
  const [member, setMember] = useState(defaultData?.email || "")
  const [role, setRole] = useState(defaultData?.role || "tenantManager")
  const [isLiveAgent, setIsLiveAgent] = useState(defaultData?.isLiveAgent || false);
  const [extendInvite, setExtendInvite] = useState(true);
  const modalLoading = useSelector((state) => state.pageDetails.modalLoading)

  const handleMemberAddition = (event) => {
    setMember(event.target.value)
  }

  const handleIsLiveAgentChanged = (event) => {

    setIsLiveAgent(event.target.checked);
  }

  const handleExtendInviteChanged = (event) => {
    setExtendInvite(event.target.checked);
  }

  const updateInvitation = () => {
    dispatch(updateInvitations(defaultData?._id, tenantId, {
      updates: {
        role,
        isLiveAgent,
      },
      extendInvite: extendInvite
    },
      () => {
        onComplete();
        notify.success({ message: `Successfully updated invitation` })
      }
    ))
  }

  return (
    <>
      <Notify />
      <Input
        placeholder="Enter email address"
        value={member}
        onChange={(e) => handleMemberAddition(e)}
        size="large"
        style={{ marginBottom: 8 }}
        disabled
      />

      <Space style={{ display: 'flex', margin: '10px 0', justifyContent: 'space-between' }} >
        <Select
          onChange={(value) => setRole(value)}
          value={role}

          size="large"
          style={{ width: "200px" }}
        >
          <Option value="tenantManager">Bot Manager</Option>
        </Select>

        <Space direction="vertical" size={0}>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>Live Agent</Typography.Text>
          <Checkbox
            checked={isLiveAgent}
            onChange={handleIsLiveAgentChanged}
          />
        </Space>

        <Space direction="vertical" size={0}>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>Extend Invite</Typography.Text>
          <Checkbox
            checked={extendInvite}
            onChange={handleExtendInviteChanged}
          />
        </Space>

        <Button
          type="primary"
          size="large"
          onClick={updateInvitation}
          loading={modalLoading}
          disabled={!member || modalLoading}
        >
          Update Invite
        </Button>
      </Space>
    </>
  )
}

export default EditMemberInvite
